module.exports = __webpack_public_path__ + "static/05-98f17ae2d7ac9c84de23098f27a931ac.jpg";